import {ImageSourcePropType, Linking} from 'react-native';

export interface BrightChampsBannerConfig {
  logo: ImageSourcePropType;
  title: string;
  tags: string[];
  tagsMobile: string[];
  offerText: string;
  couponCode: string;
  buttonText: string;
  mainImage: ImageSourcePropType;
  mainImageMobile: ImageSourcePropType;
  onPress?: () => void;
  onCopyCoupon?: () => void;
}

export const BANNER_DATA: BrightChampsBannerConfig = {
  logo: require('@/Assets/Images/Svgs/BeginnerDashboard/BrightChampsLogo.svg'),
  title: 'BrightCHAMPS for CircleChess Families',
  tags: ['Coding', 'Gen AI', 'Robotics', 'Math', 'Free Trial Class'],
  tagsMobile: ['Coding', 'Gen AI', 'Robotics', 'Math'],
  offerText: 'UP TO 25% OFF',
  couponCode: 'CIRCLECHESS25',
  buttonText: 'Book Free Trial',
  mainImage: require('@/Assets/Images/Svgs/BeginnerDashboard/GirlMathIcon.svg'),
  mainImageMobile: require('@/Assets/Images/Svgs/BeginnerDashboard/GirlMathIconMobile.svg'),
  onPress: () => {
    Linking.openURL('https://link.brightchamps.com/Fck1R5DufFyQe').catch(err =>
      console.error('Failed to open URL:', err),
    );
  },
};
